import { createBrowserRouter } from 'react-router-dom'
import PanelView from 'Presentation/Views/Panel/View'
import PublicDashboardView from 'Presentation/Views/PublicDashboard/View'

const router = createBrowserRouter([
  {
    path: '/',
    element: <PanelView />
  },
  {
    path: '/public-dashboard',
    element: <PublicDashboardView />
  }
])

export default router
